module.exports = __webpack_public_path__ + "img/iphone.0002753d.png";